import { create } from 'zustand';
import { useMessagesStore } from './messagesStore';
import { ApiUtils } from '@shared/utils';
import { MessagesApi, type SendMessageRequest } from '@shared/api/rest';
import { RequestStrategyEnum } from '@shared/api/rest/models';

interface ISendMessageStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  sendMessage: (data: Omit<SendMessageRequest, 'Id'>, reRequest?: boolean, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSendMessageStore = create<ISendMessageStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  sendMessage: ApiUtils.wrapperApi(async (data, reRequest, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      const Id = crypto.randomUUID();
      await MessagesApi.sendMessage({ ...data, Id }, signal);
      reRequest && useMessagesStore.getState().getMessages('outgoing');
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      throw error;
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, error: null, success: false }),
}));
